import React from 'react';
import { Link } from 'react-router-dom';
interface BrandButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'butter';
  href?: string;
  external?: boolean;
  className?: string;
}
export function BrandButton({
  variant = 'primary',
  href,
  external,
  className = '',
  children,
  ...props
}: BrandButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full px-8 py-3 min-h-[48px] font-body font-medium transition-all duration-300 ease-in-out text-center';
  const variants = {
    primary: 'bg-[#E91E8C] text-white hover:bg-[#C21472] shadow-sm hover:shadow-md',
    outline: 'border-2 border-[#6B1D4A] text-[#6B1D4A] hover:bg-[#6B1D4A] hover:text-white',
    butter: 'bg-[#F5D76E] text-[#6B1D4A] hover:bg-[#E3C55C] shadow-sm hover:shadow-md'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${className}`;
  if (href) {
    if (external) {
      return <a href={href} target="_blank" rel="noopener noreferrer" className={combinedClassName} data-id="element-162">
          {children}
        </a>;
    }
    return <Link to={href} className={combinedClassName} data-id="element-163">
        {children}
      </Link>;
  }
  return <button className={combinedClassName} {...props} data-id="element-164">
      {children}
    </button>;
}